"use strict";

exports.__esModule = true;
exports.formatNumeric = exports.formatGeneric = exports.formatFont = exports.formatColor = exports.formatBorder = void 0;
var _color2k = require("color2k");
var _applyThemeVariables = require("./apply-theme-variables");
const formatColor = ({
  preset,
  opacity
}, applyTheme) => {
  if (typeof opacity === 'number') {
    if ((0, _applyThemeVariables.isCssVariable)(preset)) {
      const themedValue = applyTheme(preset);
      try {
        if (themedValue !== preset && !(0, _applyThemeVariables.isCssVariable)(themedValue)) {
          const [r, g, b] = (0, _color2k.parseToRgba)(themedValue);
          return `rgba(${r}, ${g}, ${b}, ${opacity})`;
        }
        return `rgba(${preset}, ${opacity})`;
      } catch (error) {
        console.log('error formatting color', error);
        return themedValue;
      }
    } else {
      try {
        const [r, g, b] = (0, _color2k.parseToRgba)(preset);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      } catch (error) {
        console.log('error formatting color', error);
        return preset;
      }
    }
  }
  return applyTheme(preset);
};
exports.formatColor = formatColor;
const formatBorder = (value, applyTheme) => {
  const parts = [];
  if ('width' in value && value.width) {
    parts.push(formatNumeric({
      value: value.width,
      unit: 'px'
    }, applyTheme));
  }
  if ('style' in value && value.style) {
    parts.push(applyTheme(value.style));
  }
  if ('color' in value && value.color) {
    parts.push(formatColor(value.color, applyTheme));
  }
  return parts.length > 1 ? parts.join(' ') : parts[0];
};
exports.formatBorder = formatBorder;
const formatFont = (value, applyTheme) => {
  return applyTheme(value.size ? `${formatNumeric({
    value: value.size,
    unit: 'px'
  }, applyTheme)} ${value.preset}` : value.preset);
};
exports.formatFont = formatFont;
const formatNumeric = ({
  value,
  unit
}, applyTheme) => applyTheme(typeof value === 'number' ? `${value}${unit ?? ''}` : value);
exports.formatNumeric = formatNumeric;
const formatGeneric = (value, applyTheme) => applyTheme(String(value));
exports.formatGeneric = formatGeneric;
//# sourceMappingURL=formatters.js.map